import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  InputGroup,
  Label,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function GuardianDetails({
  tenantData,
  setSelectedData,
  addGuardianDetailMutate,
  isGuardianDetailLoading,
}) {
  const [data, setData] = useState(tenantData?.tenant);

  useEffect(() => {
    setData(tenantData?.tenant);
  }, [tenantData]);

  const guardianFormik = useFormik({
    initialValues: {
      fatherName: data?.fatherName || "",
      fatherMobile: data?.fatherMobile || "",
      fatherOccupation: data?.fatherOccupation || "",
      fatherAnnualIncome: data?.fatherAnnualIncome || "",
      motherName: data?.motherName || "",
      motherMobile: data?.motherMobile || "",
      localGuardian: data?.localGuardian || "",
      guardianMobile: data?.guardianMobile || "",
      guardianRelationship: data?.guardianRelationship || "",
    },
    validationSchema: Yup.object({
      fatherName: Yup.string(),
      fatherMobile: Yup.string(),
      fatherOccupation: Yup.string(),
      fatherAnnualIncome: Yup.number(),
      motherName: Yup.string(),
      motherMobile: Yup.string(),
      localGuardian: Yup.string(),
      guardianMobile: Yup.string(),
      guardianRelationship: Yup.string(),
    }),
    onSubmit: (values) => {
      if (!values.fatherName) {
        toast.error("Father's Name is required");
        return;
      }
      if (!values.fatherMobile) {
        toast.error("Father's Number is required");
        return;
      }
      if (!/^\d{10}$/.test(values.fatherMobile)) {
        toast.error("Mobile Number must be exactly 10 digits");
        return;
      }
      if (!values.fatherOccupation) {
        toast.error("Father's Occupation is required");
        return;
      }
      if (!values.fatherAnnualIncome) {
        toast.error("Annual Income is required");
        return;
      }
      if (!values.motherName) {
        toast.error("Mother's Name is required");
        return;
      }
      if (!values.motherMobile) {
        toast.error("Mother's Mobile is required");
        return;
      }
      if (!/^\d{10}$/.test(values.motherMobile)) {
        toast.error("Mobile Number must be exactly 10 digits");
        return;
      }
      if (!values.localGuardian) {
        toast.error("Local Guardian is required");
        return;
      }
      if (!values.guardianMobile) {
        toast.error("Guardian's Mobile is required");
        return;
      }
      if (!/^\d{10}$/.test(values.guardianMobile)) {
        toast.error("Mobile Number must be exactly 10 digits");
        return;
      }
      if (!values.guardianRelationship) {
        toast.error("Guardian Relationship is required");
        return;
      }
      addGuardianDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <>
      <div>
        <Title>Guardian Details</Title>
        <form
          onSubmit={guardianFormik.handleSubmit}
          className="grid grid-cols-1 gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="fatherName">Father Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherName"
                  name="fatherName"
                  value={guardianFormik.values.fatherName}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.fatherName &&
                  guardianFormik.errors.fatherName && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="fatherMobile">Father Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherMobile"
                  name="fatherMobile"
                  value={guardianFormik.values.fatherMobile}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
                {guardianFormik.touched.fatherMobile &&
                  guardianFormik.errors.fatherMobile && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherMobile}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="fatherOccupation">Father Occupation</Label>

              <FieldWrapper>
                <Select
                  id="fatherOccupation"
                  name="fatherOccupation"
                  className="w-full pl-2"
                  value={guardianFormik.values.fatherOccupation}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                >
                  <MenuItem value="Self Employed">Self Employed</MenuItem>
                  <MenuItem value="Salaried">Salaried</MenuItem>
                </Select>
                {guardianFormik.touched.fatherOccupation &&
                  guardianFormik.errors.fatherOccupation && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherOccupation}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="fatherAnnualIncome">Annual Income (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="fatherAnnualIncome"
                  name="fatherAnnualIncome"
                  value={guardianFormik.values.fatherAnnualIncome}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.fatherAnnualIncome &&
                  guardianFormik.errors.fatherAnnualIncome && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.fatherAnnualIncome}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="motherName">Mother Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="motherName"
                  name="motherName"
                  value={guardianFormik.values.motherName}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.motherName &&
                  guardianFormik.errors.motherName && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.motherName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="motherMobile">Mother Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="motherMobile"
                  name="motherMobile"
                  value={guardianFormik.values.motherMobile}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
                {guardianFormik.touched.motherMobile &&
                  guardianFormik.errors.motherMobile && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.motherMobile}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="localGuardian">Local Guardian Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="localGuardian"
                  name="localGuardian"
                  value={guardianFormik.values.localGuardian}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                />
                {guardianFormik.touched.localGuardian &&
                  guardianFormik.errors.localGuardian && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.localGuardian}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="guardianMobile">Guardian Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="guardianMobile"
                  name="guardianMobile"
                  value={guardianFormik.values.guardianMobile}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                  maxLength={10}
                />
                {guardianFormik.touched.guardianMobile &&
                  guardianFormik.errors.guardianMobile && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.guardianMobile}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="guardianRelationship">Relationship</Label>
              <FieldWrapper>
                <Select
                  id="guardianRelationship"
                  name="guardianRelationship"
                  className="w-full pl-2"
                  value={guardianFormik.values.guardianRelationship}
                  onChange={guardianFormik.handleChange}
                  onBlur={guardianFormik.handleBlur}
                >
                  <MenuItem value="Uncle">Uncle</MenuItem>
                  <MenuItem value="Aunty">Aunty</MenuItem>
                </Select>
                {guardianFormik.touched.guardianRelationship &&
                  guardianFormik.errors.guardianRelationship && (
                    <p className="text-rose-600 text-sm">
                      {guardianFormik.errors.guardianRelationship}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={isGuardianDetailLoading}>
              {isGuardianDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>
    </>
  );
}

const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const SubmitBtn = tw.button`
text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
